import PartnerLogo from '@/assets/PartnerLogo.png';
import { styled } from '@mui/material/styles';

export const mapDataToOptions = (
  data?: { id: number; name: string }[],
) =>
  (data || []).map((d) => ({
    id: d.id,
    value: d.id,
    label: d.name,
    icon: <Logo src={PartnerLogo} />,
  }));

const Logo = styled('img')({
  width: '100%',
  height: '100%',
  display: 'block',
});

export type CsvContact = { id: number; name: string; email: string };

export const parseContactsCsv = (csv?: string): CsvContact[] => {
  if (!csv) return [];
  
  try {
    const lines = csv
      .split('\n')
      .map((line) => line.trim())
      .filter((line) => line.length > 0);
    
    if (lines.length < 2) {
      return [];
    }
    
    const contacts = lines
      .slice(1)
      .map((line) => {
        const delimiter = line.includes(',') ? ',' : ';';
        const values = line
          .split(delimiter)
          .map((val) => val.trim())
          .filter((val) => val.length > 0);
        
        if (values.length < 2) {
          return null;
        }
        
        return {
          id: Math.random(),
          name: values[0],
          email: values[1],
        };
      })
      .filter((contact): contact is CsvContact => contact !== null);
    
    return contacts;
  } catch (error) {
    console.error('Error parsing CSV:', error);
    return [];
  }
};
